// @flow
import React from 'react';
import { Mutation } from '@apollo/client/react/components';
import type { PureQueryOptions } from '@apollo/client';
import SegmentListForm from './SegmentListForm';
import { wrapKnownErrors } from './errors';
import type { NewSegment, Segment, SegmentCategory } from './types';
import {
  CREATE_CLIENT_SEGMENT,
  DELETE_CLIENT_SEGMENT,
  GET_CLIENT_SEGMENT_CATEGORIES,
  UPDATE_CLIENT_SEGMENT,
} from './queries';

type SegmentListFormContainerProps = {
  clientId: string,
  segmentCategory: SegmentCategory,
};

export default function SegmentListFormContainer({
  clientId,
  segmentCategory,
}: SegmentListFormContainerProps) {
  const mutationRefetchQueries: Array<PureQueryOptions> = [
    {
      query: GET_CLIENT_SEGMENT_CATEGORIES,
      variables: { clientId },
    },
  ];
  return (
    <Mutation mutation={CREATE_CLIENT_SEGMENT} refetchQueries={mutationRefetchQueries}>
      {createClientSegment => (
        <Mutation mutation={UPDATE_CLIENT_SEGMENT} refetchQueries={mutationRefetchQueries}>
          {updateClientSegment => (
            <Mutation mutation={DELETE_CLIENT_SEGMENT} refetchQueries={mutationRefetchQueries}>
              {deleteClientSegment => (
                <SegmentListForm
                  segmentCategory={segmentCategory}
                  onSegmentAdded={({ name }: NewSegment) =>
                    createClientSegment({
                      variables: {
                        segmentInput: {
                          clientId,
                          name,
                          clientCategoryId: segmentCategory.id,
                        },
                      },
                    }).then(() => undefined, wrapKnownErrors)
                  }
                  onSegmentUpdated={({ id, name }: Segment) =>
                    updateClientSegment({
                      variables: {
                        clientSegmentId: id,
                        segmentInput: {
                          clientId,
                          name,
                        },
                      },
                      optimisticResponse: {
                        updateClientSegment: {
                          __typename: 'ClientSegment',
                          id,
                          clientCategoryId: segmentCategory.id,
                          name,
                        },
                      },
                    }).then(() => undefined, wrapKnownErrors)
                  }
                  onSegmentDeleted={({ id }: Segment) =>
                    deleteClientSegment({
                      variables: {
                        clientId,
                        segmentId: id,
                      },
                    }).then(() => undefined)
                  }
                />
              )}
            </Mutation>
          )}
        </Mutation>
      )}
    </Mutation>
  );
}
